import { createSlice } from '@reduxjs/toolkit';
import { CompendiaState, Content } from '../types/compendia.types';

const initialState: CompendiaState = {
  content: [],
  totalPages: null,
  selected: null,
};

const CompendiaSlice = createSlice({
  name: 'Compendia',
  initialState: initialState,
  reducers: {
    updateCompendiaData: (state, action) => {
      state.content = action.payload.content;
    },
    updateCompendiaPagination: (state, action) => {
      state.totalPages = action.payload.totalPages
    },
    getAllCompendiaData: (_state, _action) => {
      return;
    },
    updateSelectedCompendia: (state, action: { payload: Content }) => {
      state.selected = action.payload;
    },
    getSingleCompendiaAction: () => {
      return;
    }
  },
});

export const { updateCompendiaData, getAllCompendiaData, updateCompendiaPagination, getSingleCompendiaAction, updateSelectedCompendia } =
  CompendiaSlice.actions;
export default CompendiaSlice.reducer;
